class KlaviyoNewsletter extends HTMLElement {
    constructor() {
        super();
        this.feedbackMsgEl = this.querySelector('[data-klaviyo-newsletter-form-feedback-message]');
        this.loadingEl = this.querySelector('[data-klaviyo-newsletter-form-loading-screen]');
        this.contentEl = this.querySelector('[data-klaviyo-newsletter-form-content]');
        this.bindEvents();
    }

    bindEvents() {
        this.querySelector('form').addEventListener("submit", this.onSubscribe.bind(this));
    }

    loading() {
        this.show(this.loadingEl);
        this.hide(this.contentEl);
    }

    loaded() {
        this.hide(this.loadingEl);
    }

    clearMessage() {
        this.hide(this.feedbackMsgEl);
        this.feedbackMsgEl.classList.remove('success');
        this.feedbackMsgEl.classList.remove('failed');
        this.feedbackMsgEl.classList.remove('error');
        this.feedbackMsgEl.textContent = '';
    }

    success() {
        this.loaded()
        this.hide(document.querySelector('.footer__list-social'))
        this.show(this.querySelector('[data-klaviyo-newsletter-form-thank-you-message]'));
    }

    fail(errMsg = 'Something went wrong, try again later.', className = 'error') {
        this.loaded();
        this.feedbackMsgEl.textContent = errMsg;
        this.feedbackMsgEl.classList.add(className);
        this.show(this.feedbackMsgEl);
        this.show(this.contentEl);
    }

    /**
     * 
     * @param {SubmitEvent} evt 
     */
    onSubscribe(evt) {
        evt.preventDefault();
        this.loading();
        this.clearMessage();
        const form = evt.target;
        const req = api.luxo.createService();
        req.post(
            form.getAttribute('action'),
            (new URLSearchParams(new FormData(form)))
        ).then((res) => {
            if (res.success && res.data && res.data.status == 'success')
                this.success();
            else
                this.fail(res.data && res.data.message || '', 'failed');
        }).catch(() => this.fail());
    }

    /**
     * 
     * @param {HTMLElement} el
     */
    show(el) {
        el.classList.remove("hidden");
        el.classList.add("show");
    }
    /**
     * 
     * @param {HTMLElement} el 
     */
    hide(el) {
        el.classList.remove("show");
        el.classList.add("hidden");
    }
}

customElements.define('klaviyo-newsletter', KlaviyoNewsletter);